<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <div class="toolbar-filter-bar">
        <el-form :inline="true" class="toolbar-filter-form">
          <div class="toolbar-filter-fields">
            <el-form-item label="搜索">
              <el-input v-model="listKeyword" clearable placeholder="题干/分组" class="toolbar-field-w-lg"
                :disabled="!schoolId" @keyup.enter.native="loadBank"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" :disabled="!schoolId" @click="loadBank">查询</el-button>
            </el-form-item>
          </div>
          <div class="toolbar-filter-actions">
            <el-button type="success" size="small" icon="el-icon-plus" :disabled="!schoolId" @click="openEditDialog()">新增题目</el-button>
            <el-button type="info" size="small" icon="el-icon-refresh-left" :disabled="!schoolId" :loading="loading" @click="loadBank">刷新</el-button>
            <el-button size="small" :disabled="!schoolId" @click="openImportDialog">导入题库</el-button>
            <el-button size="small" :disabled="!schoolId" @click="handleInitSystem">恢复系统默认10题</el-button>
          </div>
        </el-form>
        <p class="hv-tip">默认题库按学校维护。「默认勾选」的题目在新建问卷时会自动预选；也可手动新增、编辑、删除单题。</p>
      </div>

      <div class="hv-table-wrap">
        <el-table :data="bankQuestions" v-loading="loading" stripe size="small" height="100%">
        <el-table-column prop="SortNo" label="题号" width="60" align="center"></el-table-column>
        <el-table-column prop="SectionTitle" label="分组" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="Title" label="题干" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column label="选项" min-width="260">
          <template slot-scope="scope">
            <span v-for="(opt, idx) in questionOptions(scope.row)" :key="opt.Id || opt.id || idx" class="hv-opt-chip">
              {{ opt.OptionKey || opt.optionKey }}.{{ opt.OptionText || opt.optionText }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="默认" width="72" align="center">
          <template slot-scope="scope">
            <el-switch v-model="scope.row._bankDefault" :disabled="!schoolId"
              @change="(val) => handleDefaultChange(scope.row, val)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="必填" width="60" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsRequired ? 'danger' : 'info'" size="mini">
              {{ scope.row.IsRequired ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <div class="table-op-pair">
              <el-button type="text" size="small" class="table-op-link" @click="openEditDialog(scope.row)">编辑</el-button>
              <el-button type="text" size="small" class="table-op-link table-op-link--danger" @click="handleDelete(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <el-col v-if="schoolId" :span="24" class="toolbar">
        <el-pagination layout="total, sizes, prev, pager, next, jumper" :current-page="page" :page-sizes="[10, 20, 50]"
          :page-size="pageSize" :total="total" style="float: right" @size-change="handleSizeChange"
          @current-change="handleCurrentChange"></el-pagination>
      </el-col>
      <div v-if="!schoolId" class="hv-empty">请在左侧选择学校</div>

      <el-dialog :title="editForm.id ? '编辑题目' : '新增题目'" :visible.sync="editDialogVisible" width="640px"
        custom-class="hv-edit-dialog" @closed="resetEditForm">
        <el-form label-width="88px" size="small" class="hv-edit-form">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="题号">
                <el-input-number v-model="editForm.sortNo" :min="1" :max="999" controls-position="right"
                  style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="分组">
                <el-input v-model="editForm.sectionTitle" placeholder="如：一、居家学习"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="题干" required>
            <el-input v-model="editForm.title" type="textarea" :rows="2" placeholder="请输入题干"></el-input>
          </el-form-item>
          <el-form-item label="选项" required class="hv-options-item">
            <div class="hv-options-panel">
              <div v-for="(opt, idx) in editForm.optionTexts" :key="idx" class="hv-opt-row">
                <span class="hv-opt-badge">{{ optionKeys[idx] }}</span>
                <el-input v-model="editForm.optionTexts[idx]" placeholder="请输入选项内容" class="hv-opt-input"></el-input>
                <el-button v-if="editForm.optionTexts.length > 2" type="text" icon="el-icon-delete"
                  class="hv-opt-del" title="删除该选项" @click="removeOption(idx)"></el-button>
                <span v-else class="hv-opt-del-placeholder"></span>
              </div>
              <el-button v-if="editForm.optionTexts.length < 6" type="text" icon="el-icon-plus"
                class="hv-opt-add" @click="addOption">添加选项</el-button>
            </div>
          </el-form-item>
          <div class="hv-edit-switches">
            <el-form-item label="默认勾选">
              <el-switch v-model="editForm.isBankDefault"></el-switch>
              <span class="hv-switch-tip">新建问卷时自动选中</span>
            </el-form-item>
            <el-form-item label="必填">
              <el-switch v-model="editForm.isRequired"></el-switch>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="hv-edit-footer">
          <el-button @click="editDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="saving" @click="submitEdit">保存</el-button>
        </div>
      </el-dialog>

      <el-dialog title="导入默认题库" :visible.sync="importDialogVisible" width="520px" @closed="resetImportForm">
        <div class="hv-import-panel">
          <div class="hv-import-step">
            <span class="hv-step-no">1</span>
            <div class="hv-step-body">
              <div class="hv-step-title">下载 Excel 模板</div>
              <div class="hv-step-desc">按模板填写题目与选项后上传，将全量覆盖当前题库。</div>
              <el-button type="primary" plain icon="el-icon-download" size="small" @click="handleDownloadTemplate">
                下载导入模板
              </el-button>
            </div>
          </div>
          <div class="hv-import-step">
            <span class="hv-step-no">2</span>
            <div class="hv-step-body">
              <div class="hv-step-title">上传 Excel 文件</div>
              <el-upload class="hv-upload-block" drag action="#" :auto-upload="false" :limit="1"
                accept=".xlsx,.xls" :file-list="importFileList" :on-change="onImportFileChange"
                :on-remove="onImportFileRemove">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">仅支持 .xlsx / .xls</div>
              </el-upload>
            </div>
          </div>
        </div>
        <div slot="footer">
          <el-button @click="importDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="importing" :disabled="!importFileRaw" @click="submitImport">
            开始导入
          </el-button>
        </div>
      </el-dialog>

      <el-dialog title="导入结果" :visible.sync="resultDialogVisible" width="760px">
        <div class="hv-result-summary">
          <el-tag :type="importErrorRows.length ? 'warning' : 'success'" size="small">{{ importResultMsg }}</el-tag>
          <span v-if="importDetailQuestions.length" class="hv-result-count">共 {{ importDetailQuestions.length }} 题</span>
        </div>
        <div v-if="importErrorRows.length" class="hv-result-block">
          <div class="hv-result-label">错误明细</div>
          <el-table :data="importErrorRows" size="mini" max-height="160">
            <el-table-column prop="rowNumber" label="行号" width="80"></el-table-column>
            <el-table-column prop="message" label="错误说明" min-width="200"></el-table-column>
          </el-table>
        </div>
        <div v-if="importDetailQuestions.length" class="hv-result-block">
          <div class="hv-result-label">题目明细</div>
          <el-table :data="importDetailQuestions" size="mini" max-height="320">
            <el-table-column prop="SortNo" label="题号" width="55" align="center"></el-table-column>
            <el-table-column prop="SectionTitle" label="分组" width="110" show-overflow-tooltip></el-table-column>
            <el-table-column prop="Title" label="题干" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="选项" min-width="200">
              <template slot-scope="scope">
                <span v-for="(opt, idx) in questionOptions(scope.row)" :key="opt.Id || opt.id || idx" class="hv-opt-chip">
                  {{ opt.OptionKey || opt.optionKey }}.{{ opt.OptionText || opt.optionText }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="默认" width="55" align="center">
              <template slot-scope="scope">{{ isBankDefault(scope.row) ? '是' : '否' }}</template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer">
          <el-button type="primary" @click="resultDialogVisible = false">知道了</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from "../../components/DepartmentPane";
import {
  getHomeVisitQuestionBank,
  getHomeVisitQuestionBankAll,
  importHomeVisitQuestionBank,
  initHomeVisitQuestionBank,
  saveHomeVisitQuestionBankItem,
  deleteHomeVisitQuestionBankItem,
  setHomeVisitQuestionBankItemDefault,
  downloadHomeVisitImportTemplate,
  downloadBlobExcel,
  onHomeVisitSchoolChange,
  resolveHomeVisitSchoolIdFromTreeNode,
  homeVisitQuestionOptions,
  isHomeVisitBankDefault
} from "@/api/homeVisit";

export default {
  components: { DepartmentPane },
  data() {
    return {
      DepartmentId: 0,
      schoolId: 0,
      bankQuestions: [],
      total: 0,
      listKeyword: "",
      page: 1,
      pageSize: 10,
      loading: false,
      saving: false,
      importing: false,
      importDialogVisible: false,
      resultDialogVisible: false,
      editDialogVisible: false,
      importFileList: [],
      importFileRaw: null,
      importResultMsg: "",
      importErrorRows: [],
      importDetailQuestions: [],
      optionKeys: ["A", "B", "C", "D", "E", "F"],
      editForm: {
        id: null,
        sortNo: 1,
        sectionTitle: "",
        title: "",
        optionTexts: ["", "", "", ""],
        isRequired: true,
        isBankDefault: true
      }
    };
  },
  methods: {
    questionOptions: homeVisitQuestionOptions,
    isBankDefault: isHomeVisitBankDefault,

    async treeNodeClick(data, node) {
      onHomeVisitSchoolChange(this, data.value);
      this.schoolId = resolveHomeVisitSchoolIdFromTreeNode(node, data.value);
      this.listKeyword = "";
      this.page = 1;
      await this.loadBank();
    },

    handleCurrentChange(val) {
      this.page = val;
      this.loadBank();
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.loadBank();
    },

    async loadBank() {
      if (!this.schoolId) {
        this.bankQuestions = [];
        this.total = 0;
        return null;
      }
      this.loading = true;
      try {
        const res = await getHomeVisitQuestionBank({
          schoolDepartmentId: this.schoolId,
          keyword: (this.listKeyword || "").trim() || undefined,
          page: this.page,
          pageSize: this.pageSize
        });
        const d = res.data;
        if (d.success && d.response) {
          const pageData = d.response;
          const list = pageData.data || [];
          this.total = pageData.dataCount || 0;
          const maxPage = Math.max(1, Math.ceil(this.total / this.pageSize));
          if (this.total > 0 && this.page > maxPage) {
            this.page = maxPage;
            return this.loadBank();
          }
          this.bankQuestions = list.map((row) => ({
            ...row,
            _bankDefault: isHomeVisitBankDefault(row)
          }));
          return this.bankQuestions;
        }
        this.bankQuestions = [];
        this.total = 0;
        this.$message.error(d.msg || "加载失败");
        return null;
      } finally {
        this.loading = false;
      }
    },

    openEditDialog(row) {
      if (!this.schoolId) return;
      if (row) {
        const opts = this.questionOptions(row).map((o) => o.OptionText || o.optionText || "");
        this.editForm = {
          id: row.Id || row.id,
          sortNo: row.SortNo || row.sortNo || 1,
          sectionTitle: row.SectionTitle || row.sectionTitle || "",
          title: row.Title || row.title || "",
          optionTexts: opts.length >= 2 ? [...opts] : ["", "", "", ""],
          isRequired: row.IsRequired != null ? row.IsRequired : row.isRequired !== false,
          isBankDefault: isHomeVisitBankDefault(row)
        };
      } else {
        const nextNo = this.total ? this.total + 1 : 1;
        this.editForm = {
          id: null,
          sortNo: nextNo,
          sectionTitle: "",
          title: "",
          optionTexts: ["", "", "", ""],
          isRequired: true,
          isBankDefault: true
        };
      }
      this.editDialogVisible = true;
    },

    resetEditForm() {
      this.saving = false;
    },

    addOption() {
      if (this.editForm.optionTexts.length < 6) {
        this.editForm.optionTexts.push("");
      }
    },

    removeOption(idx) {
      if (this.editForm.optionTexts.length > 2) {
        this.editForm.optionTexts.splice(idx, 1);
      }
    },

    async submitEdit() {
      if (!this.editForm.title || !this.editForm.title.trim()) {
        this.$message.warning("请填写题干");
        return;
      }
      const optionTexts = this.editForm.optionTexts.map((t) => (t || "").trim()).filter(Boolean);
      if (optionTexts.length < 2) {
        this.$message.warning("至少需要两个选项");
        return;
      }
      this.saving = true;
      try {
        const res = await saveHomeVisitQuestionBankItem({
          SchoolDepartmentId: this.schoolId,
          Id: this.editForm.id || null,
          SortNo: this.editForm.sortNo,
          SectionTitle: this.editForm.sectionTitle,
          Title: this.editForm.title.trim(),
          IsRequired: this.editForm.isRequired,
          IsBankDefault: this.editForm.isBankDefault,
          OptionTexts: optionTexts
        });
        const d = res.data;
        if (d.success) {
          this.$message.success("保存成功");
          this.editDialogVisible = false;
          await this.loadBank();
        } else {
          this.$message.error(d.msg || "保存失败");
        }
      } finally {
        this.saving = false;
      }
    },

    async handleDefaultChange(row, val) {
      const id = row.Id || row.id;
      const res = await setHomeVisitQuestionBankItemDefault({
        QuestionId: id,
        IsBankDefault: !!val
      });
      const d = res.data;
      if (d.success) {
        row.IsBankDefault = !!val;
        row._bankDefault = !!val;
      } else {
        row._bankDefault = !val;
        this.$message.error(d.msg || "更新失败");
      }
    },

    async handleDelete(row) {
      try {
        await this.$confirm("确认删除该题目？", "提示", { type: "warning" });
      } catch (e) {
        return;
      }
      const res = await deleteHomeVisitQuestionBankItem(this.schoolId, row.Id || row.id);
      const d = res.data;
      if (d.success) {
        this.$message.success("删除成功");
        await this.loadBank();
      } else {
        this.$message.error(d.msg || "删除失败");
      }
    },

    openImportDialog() {
      if (!this.schoolId) return;
      this.resetImportForm();
      this.importDialogVisible = true;
    },

    resetImportForm() {
      this.importFileList = [];
      this.importFileRaw = null;
    },

    onImportFileChange(file, fileList) {
      this.importFileList = fileList.slice(-1);
      this.importFileRaw = file && file.raw ? file.raw : null;
    },

    onImportFileRemove() {
      this.importFileList = [];
      this.importFileRaw = null;
    },

    handleDownloadTemplate() {
      downloadHomeVisitImportTemplate()
        .then((res) => downloadBlobExcel(res, "家访问卷导入模板"))
        .catch(() => this.$message.error("下载失败"));
    },

    async submitImport() {
      if (!this.importFileRaw || !this.schoolId) {
        this.$message.warning("请先选择 Excel 文件");
        return;
      }
      const form = new FormData();
      form.append("file", this.importFileRaw);
      this.importing = true;
      try {
        const res = await importHomeVisitQuestionBank(form, this.schoolId);
        const d = res.data;
        if (d.success && d.response) {
          const r = d.response;
          const successCount = r.SuccessCount != null ? r.SuccessCount : (r.successCount || 0);
          const errors = (r.Errors || r.errors || []).map((x) => ({
            rowNumber: x.RowNumber != null ? x.RowNumber : x.rowNumber,
            message: x.Message != null ? x.Message : x.message
          }));
          this.importErrorRows = errors;
          this.importResultMsg = errors.length
            ? `成功导入 ${successCount} 题，另有 ${errors.length} 行未导入`
            : `成功导入 ${successCount} 题`;
          this.importDialogVisible = false;
          await this.loadBank();
          const allRes = await getHomeVisitQuestionBankAll(this.schoolId);
          const allData = allRes.data;
          this.importDetailQuestions = allData.success && allData.response ? [...allData.response] : [];
          this.resultDialogVisible = true;
          this.$message.success(d.msg || "导入完成");
        } else {
          this.$message.error(d.msg || "导入失败");
        }
      } catch (e) {
        this.$message.error("导入请求失败");
      } finally {
        this.importing = false;
      }
    },

    async handleInitSystem() {
      try {
        await this.$confirm("将用系统默认 10 题全量覆盖当前题库，是否继续？", "提示", { type: "warning" });
      } catch (e) {
        return;
      }
      const res = await initHomeVisitQuestionBank(this.schoolId);
      const d = res.data;
      if (d.success) {
        this.$message.success(d.msg || "已恢复");
        await this.loadBank();
      } else {
        this.$message.error(d.msg || "操作失败");
      }
    }
  }
};
</script>

<style scoped>
.hv-table-wrap {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
.hv-table-wrap >>> .el-table {
  width: 100%;
  height: 100%;
}
.hv-empty { flex: 0 0 auto; color: #909399; padding: 24px 0; }
.hv-tip { color: #909399; font-size: 13px; margin: 0 0 12px; }
.hv-danger { color: #f56c6c; }
.hv-opt-chip {
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 4px;
  font-size: 12px;
  color: #606266;
}
.hv-switch-tip { margin-left: 8px; font-size: 12px; color: #909399; }
.hv-import-panel { padding: 0 4px; }
.hv-import-step { display: flex; gap: 12px; margin-bottom: 20px; }
.hv-import-step:last-child { margin-bottom: 0; }
.hv-step-no {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 50%;
  background: var(--btn-primary, #2563eb);
  color: #fff;
  font-size: 13px;
}
.hv-step-body { flex: 1; min-width: 0; }
.hv-step-title { font-weight: 600; margin-bottom: 6px; color: #303133; }
.hv-step-desc { font-size: 13px; color: #909399; margin-bottom: 10px; }
.hv-upload-block { width: 100%; }
.hv-upload-block >>> .el-upload { width: 100%; }
.hv-upload-block >>> .el-upload-dragger { width: 100%; }
.hv-result-summary { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; }
.hv-result-count { font-size: 13px; color: #606266; }
.hv-result-block { margin-bottom: 16px; }
.hv-result-block:last-child { margin-bottom: 0; }
.hv-result-label { font-size: 13px; font-weight: 600; color: #303133; margin-bottom: 8px; }
</style>

<style>
/* 编辑题目弹窗（挂载到 body，不可 scoped） */
.hv-edit-dialog .el-dialog__body {
  padding: 16px 24px 8px;
}
.hv-edit-dialog .hv-edit-form .el-form-item {
  margin-bottom: 16px;
}
.hv-edit-dialog .hv-edit-form .el-form-item__label {
  font-weight: 500;
  color: #606266;
}
.hv-edit-dialog .hv-options-item .el-form-item__content {
  line-height: normal;
}
.hv-edit-dialog .hv-options-panel {
  width: 100%;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  box-sizing: border-box;
}
.hv-edit-dialog .hv-opt-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.hv-edit-dialog .hv-opt-row:last-of-type {
  margin-bottom: 0;
}
.hv-edit-dialog .hv-opt-badge {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 6px;
  background: linear-gradient(135deg, var(--btn-primary, #2563eb), #337ecc);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}
.hv-edit-dialog .hv-opt-input {
  flex: 1;
  min-width: 0;
}
.hv-edit-dialog .hv-opt-del {
  flex-shrink: 0;
  width: 32px;
  padding: 0;
  font-size: 16px;
  color: #c0c4cc;
}
.hv-edit-dialog .hv-opt-del:hover {
  color: #f56c6c;
}
.hv-edit-dialog .hv-opt-del-placeholder {
  flex-shrink: 0;
  width: 32px;
}
.hv-edit-dialog .hv-opt-add {
  display: block;
  width: 100%;
  margin-top: 12px;
  padding: 8px 0;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  color: var(--btn-primary, #2563eb);
  text-align: center;
}
.hv-edit-dialog .hv-opt-add:hover {
  border-color: var(--btn-primary, #2563eb);
  background: #ecf5ff;
}
.hv-edit-dialog .hv-edit-switches {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 32px;
  padding-top: 4px;
  border-top: 1px solid #f0f2f5;
}
.hv-edit-dialog .hv-edit-switches .el-form-item {
  margin-bottom: 8px;
}
.hv-edit-dialog .hv-edit-footer {
  padding-top: 4px;
}
</style>
